import { Grid, Paper, Box, Button } from '@material-ui/core';
import { useLocalization } from 'contexto/localization/useLocalization';
import React, { forwardRef } from 'react';
import MaterialTable from '@material-table/core';
import VisibilityIcon from '@material-ui/icons/Visibility';

const ListaPaginadaPagos = forwardRef(function ListaPaginadaPagos({
    filtro = '',
}, tableRef) {
    //Idioma
    const { strings } = useLocalization();
    //Token

    //Estados

    //Parametros URL 

    //Paginador
    const columnasTabla = [
        {
            title: strings.modules.codigoContrato,
            field: 'cntContrato.codigo'
        },
        {
            title: strings.modules.codigo,
            field: 'codigo'
        },
        {
            title: strings.modules.tipo,
            field: 'tipoVersionContrato.nombre'
        }
    ];
    return (
        <Grid container>
            <Grid item xs={12} md={12}>
                <MaterialTable
                    title=''
                    tableRef={tableRef}
                    columns={columnasTabla}
                    data={[]}
                    localization={strings.components.materialTable}
                    options={{
                        actionsColumnIndex: -1, pageSize: 10, debounceInterval: 600, sorting: true,
                        pageSizeOptions: [10, 50, 100, 200],
                    }}
                    actions={[rowData => ({})]}
                    components={{
                        Container: props => <Paper {...props} elevation={0} />,
                        Action: props => (
                            <Box display='inline-flex'>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disableElevation
                                    size="small"
                                    style={{ marginRight: 5 }}
                                    onClick={() => console.log('aaa')}
                                >
                                    <VisibilityIcon />
                                </Button>
                            </Box>
                        )
                    }}
                />
            </Grid>
        </Grid>
    )
});

export default ListaPaginadaPagos;